
import { uniqBy } from 'lodash';
import ChecklistComponent from '../../components/ChecklistComponent.vue';
import ActivitiesComponent from '../../components/ActivitiesComponent.vue';
import adsApi from '../../libs/ads-request/ads-api';

export default {
  name: 'ChecklistMobile',
  components: {
    ActivitiesComponent,
    ChecklistComponent,
  },
  props: {
    red: {
      type: Array,
      default: () => [],
    },
    yellow: {
      type: Array,
      default: () => [],
    },
    green: {
      type: Array,
      default: () => [],
    },
    reset: Boolean,
  },
  data: () => ({
    showTutorial: false,
    isAdditionalBudgets: false,
    unbudgedList: [],
  }),
  watch: {
    reset() {
      this.activitySelected = null;
    },
  },
  created() {
    this.isAdditionalBudgets = this.$session.get('showAdditionalBudgets');
    this.getUnbudgetedActivities();
  },
  methods: {
    changeTutorial(status) {
      this.showTutorial = status;
    },
    getUnbudgetedActivities() {
      return adsApi.getUnbudgetedActivities()
        .then((orders) => {
          const ordersArray = orders[0].activityClient;
          this.unbudgedList = uniqBy(ordersArray, 'order_activity_id');
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
